<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <div class="title-bc">账户管理</div>
        </div>
        <div class="box-header-right">
          <div class="line-right">
            <el-button type="primary" @click="dialogTableVisible = true"
              >修改密码</el-button
            >
            <el-button type="primary">切换账户</el-button>
            <el-button type="primary">退出账户</el-button>
          </div>
        </div>
      </div>
      <!--内容-->
      <div class="box-content">
        <div
          class="box-item box-half"
          style="width: 100%; background-color: transparent; margin-bottom: 0px; padding-bottom: 0px"
        >
          <div class="box-item-img">
            <img src="../../assets/img/空白头像@2x.png" />
          </div>
          <div class="box-item-text" style="width: 100%">
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">用户名</span>
                <el-input placeholder="" type="text" v-model="username">
                </el-input>
              </div>
            </div>
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">手机号</span>
                <el-input placeholder="" type="text" v-model="phone">
                </el-input>
              </div>
            </div>
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">邮箱</span>
                <el-input placeholder="" type="text" v-model="email">
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div
          class="box-item box-half"
          style="width: 100%; background-color: transparent;margin-top: 0px; padding-top: 0px;"
        >
          <div class="box-item-text" style="width: 100%">
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">公司</span>
                <el-input placeholder="" type="text" v-model="company">
                </el-input>
              </div>
            </div>
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">地址</span>
                <el-input placeholder="" type="text" v-model="address">
                </el-input>
              </div>
            </div>
            <div style="margin-top: 20px">
              <el-button type="warning" style="float: right">{{
                $t("m.commentDetail.saveChange")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--------修改密码弹框---------->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">旧密码</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">新密码</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">确认密码</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div
          type="primary"
          @click="dialogTableVisible = false"
          class="dialog-footer-btn"
        >
          保 存
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "equipment-list",
  data() {
    return {
      username: "",
      date: "",
      phone: "",
      email: "",
      company: "",
      address: "",
      remarks: "",
      selectValue: "",
      dialogTableVisible: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.el-textarea__inner {
  height: 250px;
}

.box-item .box-item-img img {
  width: 80px;
}
</style>
